import React from "react"
import "./about.css"

export const About = () => {
  return (
    <div className="about-box">
      <h3>Hi, I'm Austin Abbott.</h3>
      <p>
        I'm a Software Engineer working in Fintech with experience in
        JavaScript, TypeScript, React, Preact, Gatsby, HTML, and CSS. I've dabbled in full stack
        development with Node, Express, and PostgreSQL.
      </p>
    </div>
  )
}
